define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi",
    "csi/constants",
    "csi/def",
    "csi/def/Action",
    "csi/def/Field",
    "csi/def/Relationship",
    "csi/def/ViewRef",
    "csi/form/Widget",
    "csi/locale",
    "csi/reflection",
    "csi/store/_base",
    "csi/store/GroupQueryEngine",
    "csi/store/Names",
    "csi/xml",
    "csi/xml/Query",
    "underscore",
    "Apparel/ProductColorMixin"
], function(declare,lang,csi,constants,def,Action,Field,Relationship,ViewRef,Widget,locale,reflection,csiStore,GroupQueryEngine,Names,xml,Query,_,ProductColorMixin) {

    function processResultNodePartMaterials(/*Node*/node, /*Cache*/cache) {
        //S10146 summary: add Material Name after PartMaterial Name
        var material = cache.getNode(node.Actual);
        var item = {$:node.$URL, Name: locale.getNodeConfiguredName(node, cache) + " " + locale.getNodeConfiguredName(material, cache), node:node};
        return item;
    }

    return declare([Widget,ProductColorMixin], {

        FIELD_PART_MATERIALS: "PartMaterials",
        FIELD_COLORWAYS: "Colorways",
        FIELD_FROM: "From",
        FIELD_TO: "To",
        FIELD_SECTION: "BomSections",

        onValidateColorSpecFields: function(formView, field, value, params) {
            var	from = this.defView.getFieldValue(this.FIELD_FROM);
            var	to = this.defView.getFieldValue(this.FIELD_TO);
            if (!xml.isEmptyURL(from) && !xml.isEmptyURL(to) && from == to) {
                throw new Error(locale.resource("ColorSpecToAndFromError"));
            }
        },

        _getStoreOptions(/*Field*/ field) {
            let storeOptions;
            const ctx = this.getContext();

            if (field.getControlName() === this.FIELD_PART_MATERIALS) {
                storeOptions = {
                    customOperation: true,
                _processResultNode: processResultNodePartMaterials
                };
            } else if (field.getControlName() === this.FIELD_TO && this._isColorRuleEnforcedOrEnabled(ctx)) {
                storeOptions = {
                    customOperation: true,
                    data: [csiStore.nameObject("")],
                    queryEngine: GroupQueryEngine,
                    requestParameters: {
                       [constants.DEP_PATH]: reflection.PATH_PARENT
                    },
                    _processResultNode: function(node,cache) {
                       const parent = cache.getNode(node.__Parent__);
                       const groupName = parent && node.$Type == "ColorInPalette" ? parent.$Name : "";
                       return {$:node.$URL, Name:node.$Name, node:node, group:groupName};
                    }
                };
            } else if (field.getControlName() === this.FIELD_TO) {
                storeOptions = {
                    data: [csiStore.nameObject("")]
                }
            }

            return csiStore.namesOptionsByRelationship(ctx, field.m_relationship, storeOptions);
        },



        getFieldStore: function(/*Field*/field, /*String*/value) {
            const ac = this.getFormData().getSource();
            let storeOptions = null;
            let q = new Query();
            switch(field.getControlName()){

                case this.FIELD_SECTION:
                    return ac._sectionsStore;

                case this.FIELD_PART_MATERIALS:
                    // special store to add PartMaterials view, so that Go to Dialog is available on the field
                    // add dependency path to get the Actual
                    const selectedSectionNames = this.defView.getFieldValue(this.FIELD_SECTION);
                    if (selectedSectionNames != null && selectedSectionNames.length > 0) {
                        var selectedSections = this.getViewNode().AllSections.filter((cnl) => {
                            const section = ac.getCache().getNode(cnl);
                            if (!section || !xml.isValidURL(cnl)) {
                                return false;
                            }
                            return _.contains(selectedSectionNames, section.$Name);
                        });

                        // Add the "blanks" section if it is present.
                        if (_.contains(selectedSectionNames, xml.VALUE_BLANK)) {
                            selectedSections.push(csi.EMPTY_URL);
                        }
                        if (selectedSections != null && selectedSections.length > 0) {
                            _.each(selectedSections, function(section) {
                                this.RefAttr("DSSection", xml.OP_EQUALS, section);
                            }, q.Or());
                        }

                        field.m_relationship.addQuery(q, true);
                    }

                    storeOptions = this._getStoreOptions(field);
                    storeOptions.action = lang.mixin(new Action(),{
                        m_viewRef: lang.mixin(new ViewRef(), {
                            m_id: "PartMaterialsPopup",
                            m_url: this.getViewNode().__Parent__
                        }),
                    });
                    storeOptions.request.addDependencyPaths(field.m_relationship.m_depPaths);
                    return new Names(storeOptions);

                case this.FIELD_COLORWAYS:
                    storeOptions = this._getStoreOptions(field);
                    storeOptions.action = lang.mixin(new Action(),{
                        m_viewRef: lang.mixin(new ViewRef(), {
                            m_id: "ProductColors",
                            m_url: this.getViewNode().__Parent__
                        })
                    });
                    return new Names(storeOptions);

                case this.FIELD_TO:
                    const ctx = this.getContext();
                    const styleUrl = this._getStyle(ctx).$URL;
                    this._applyProducColorSpecFilters(ctx,q);
                    let rel = lang.mixin(new Relationship(), {
                        m_query: q
                    })
                    field.m_relationship = rel;
                    storeOptions = this._getStoreOptions(field);
                    storeOptions.action = lang.mixin(new Action(),{
                        m_fixedQuery: q,
                        m_viewRef: lang.mixin(new ViewRef(), {
                            m_id: this._isColorRuleEnforcedOrEnabled(ctx) ? "ProductColorSpecsWithPaletteSelector" : "CombinedColors",
                            m_url: styleUrl
                        }),
                        classControllerParams: {
                            onCreatePopupParams: function(params) {
                                params.productUrl = styleUrl;
                            }
                        }
                    });
                    return new Names(storeOptions);

                default:
                    return this.inherited(arguments);
            }
        }

    });
});